import { ChangeDetectorRef, ElementRef, EventEmitter, HostBinding,
    HostListener, Injector, AfterViewInit, Optional, Output, OnDestroy, Type, Directive } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroupDirective, NgControl, NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive()
export class ValueAccessor implements AfterViewInit, OnDestroy, ControlValueAccessor {

    @HostBinding('attr.invalid') get isInvalid(): boolean {
        if (!this.ngControl) {
            return false;
        }

        const isSubmitted = (this.parent && this.parent.submitted);
        return this.ngControl.invalid && (this.ngControl.touched || isSubmitted);
    }

    /**
     * Enable two-way binding
     */
    @Output() public readonly valueChange: EventEmitter<any> = new EventEmitter<any>();

    protected ngControl: FormControl;
    protected lastValue: any;
    private readonly parent: NgForm | FormGroupDirective | null;
    private parentSubscription: Subscription;
    private onChange: (value: any) => void = () => {/**/};
    onTouched: () => void = () => {/**/};

    constructor(
        protected element: ElementRef,
        parentForm: NgForm,
        parentGroup: FormGroupDirective,
        protected injector: Injector,
        @Optional() protected changeRef: ChangeDetectorRef) {
            this.parent = parentForm ? parentForm : parentGroup ? parentGroup : null;
    }

    ngAfterViewInit() {
        const control: NgControl = this.injector.get<NgControl>(NgControl as unknown as Type<NgControl>, null);

        if (control) {
            this.ngControl = control.control as FormControl;
            this.element.nativeElement.validationStrategy = this;
        }

        if (this.parent && this.parent.statusChanges) {
            this.parentSubscription = this.parent.statusChanges.subscribe({
                next: () => {
                    this.changeRef.markForCheck();
                }
            });
        }
    }

    ngOnDestroy(): void {
        if (this.parentSubscription) {
            this.parentSubscription.unsubscribe();
        }
    }

    @HostListener('anjBlur')
    onAnjBlur() {
        this.onTouched();
    }

    writeValue(value: any) {
        this.element.nativeElement.value = this.lastValue = value == null ? '' : value;
    }

    onChangeEvent(value: any) {
        if (value !== this.lastValue) {
            this.lastValue = value;
            this.onChange(value);
            this.valueChange.emit(value);
        }
    }

    registerOnChange(fn: (value: any) => void) {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean) {
        this.element.nativeElement.disabled = isDisabled;
    }

    // Called by Anjuna Element, so needs to exist, but Angular does all the hoof-work
    onValidChange() { /**/ }
}
